export const DayOfWeekInputs = [
  { name: 'name', label: "Name", type: 'text', defaultValue: '', validation: { required: "Please enter a name" } },
  { name: 'monday', label: "Monday", type: 'checkbox', defaultValue: false },
  { name: 'tuesday', label: "Tuesday", type: 'checkbox', defaultValue: false },
  { name: 'wednesday', label: "Wednesday", type: 'checkbox', defaultValue: false },
  { name: 'thursday', label: "Thursday", type: 'checkbox', defaultValue: false },
  { name: 'friday', label: "Friday", type: 'checkbox', defaultValue: false },
  { name: 'saturday', label: "Saturday", type: 'checkbox', defaultValue: false },
  { name: 'sunday', label: "Sunday", type: 'checkbox', defaultValue: false },
];